import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useBuscadorGlobalStyles } from './styles/BuscadorGlobalStyles';

const NoResults = ({ textoBusqueda, labels = {} }) => {
    const classes = useBuscadorGlobalStyles();

    return (
        <Box className={classes.contenedorSinResultados}>
            <SearchOffIcon className={classes.iconoSinResultados} />
            <Typography className={classes.textoSinResultados}>
                {labels.Et_SinResultados} "{textoBusqueda}"
            </Typography>
            <Typography 
                variant="caption" 
                color="textSecondary"
                sx={{ marginTop: 1 }}
            >
                {labels.Et_IntentaOtrosTerminos}
            </Typography>
        </Box>
    );
};

export default NoResults;
